// src/components/Footer.js
import React from 'react';
import '../styles/components/Footer.css'; // Стили для нижней шапки

const Footer = () => {
    return (
        <footer className="footer">
            <p>© 2026 AliceEge. Все права защищены</p>
            <p className="footer-links">
                <a
                    href="https://telegra.ph/Publichnaya-oferta-na-predostavlenie-dostupa-k-zakrytym-informacionnym-kanalam-proekta-AliceEge-07-18"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Договор оферты
                </a>
                <span> | </span>
                <a
                    href="https://telegra.ph/Politika-konfidencialnosti-proekta-AliceEge-07-18"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Политика конфиденциальности
                </a>
            </p>
            <p>
                <a href="https://t.me/+KmKurCQp2tIzZDgy" target="_blank" rel="noopener noreferrer">
                    Перейти в телеграм канал
                </a>
            </p>
        </footer>
    );
};

export default Footer;
